import React, { Component } from "react";
import PropTypes from "prop-types";
import { DragSource, DropTarget } from "react-dnd";
import ItemTypes from "./ItemTypes";

const itemSource = {
  beginDrag(props) {
    return {
      id: props.id,
      originalIndex: props.findItem(props.id).index
    };
  },

  endDrag(props, monitor) {
    const { id: droppedId, originalIndex } = monitor.getItem();
    const didDrop = monitor.didDrop();

    if (!didDrop) {
      props.moveItem(droppedId, originalIndex);
    }
  }
};

const itemTarget = {
  canDrop() {
    return false;
  },

  hover(props, monitor) {
    const { id: draggedId } = monitor.getItem();
    const { id: overId } = props;

    if (draggedId !== overId) {
      const { index: overIndex } = props.findItem(overId);
      props.moveItem(draggedId, overIndex);
    }
  }
};

const dropTarget = connect => ({
  connectDropTarget: connect.dropTarget()
});
const dragSource = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
});

class Item extends Component {
  render() {
    const {
      id,
      title,
      isDragging,
      isSelected,
      connectDragSource,
      connectDropTarget,
      selectItem,
      movable,
      isEdit,
      classes,
      index
    } = this.props;
    const opacity = isDragging ? 0.3 : 1;
    const selectedStyle = isSelected
      ? {
        backgroundColor: "#26a69a",
        color: "#FFF"
      }
      : {
        backgroundColor: "transparent",
        color: "#575962"
      };
    const cursor = movable && isEdit ? "move" : "pointer";
    const titleStyle = {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: 190
    };
    if (movable && isEdit) {
      return connectDragSource(
        connectDropTarget(
          <div
            role="button"
            id={id}
            tabIndex={id}
            onClick={() => selectItem(id)}
            onKeyPress={() => selectItem(id)}
            className={classes.addButton}
            style={{
              opacity,
              ...selectedStyle,
              cursor,
              display: "inline-flex",
              alignItems: "center",
              width: 240
            }}
          >
            <div style={{ width: 50 }}>{`Q${index}`}</div>
            <div style={{ ...titleStyle }}>{title}</div>
          </div>
        )
      );
    }
    return (
      <div
        role="button"
        id={id}
        tabIndex={id}
        onClick={() => selectItem(id)}
        onKeyPress={() => selectItem(id)}
        className={classes.addButton}
        style={{
          opacity,
          ...selectedStyle,
          cursor,
          display: "inline-flex",
          alignItems: "center",
          width: 240
        }}
      >
        <div style={{ width: 50 }}>{`Q${index}`}</div>
        <div style={{ ...titleStyle }}>{title}</div>
      </div>
    );
  }
}

Item.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  id: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  moveItem: PropTypes.func.isRequired,
  findItem: PropTypes.func.isRequired
};
export default DragSource(ItemTypes.ITEM, itemSource, dragSource)(
  DropTarget(ItemTypes.ITEM, itemTarget, dropTarget)(Item)
);



// WEBPACK FOOTER //
// ./src/components/CreateSurvey/BaseWord/Item.jsx